import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { PointsCashCardBrands, PointsCashContainer, PointsCashContent } from '.'

class PointsCash extends Component {
  render () {
    if (this.props.paymentSelected === 'POINTS_CASH') {
      return (
        <PointsCashContainer
          radioSelected
          selectPointsCash={this.props.selectPointsCash}
        >
          <PointsCashContent {...this.props} sliderAriaLabelledby='cashPointsTxt' />
        </PointsCashContainer>
      )
    }

    return (
      <PointsCashContainer
        {...this.props}
        radioSelected={false}
        title={<PointsCashCardBrands brands={this.props.brands} />}
      />
    )
  }
}

PointsCash.propTypes = {
  brands: PropTypes.array,
  paymentSelected: PropTypes.string.isRequired,
  selectPointsCash: PropTypes.func.isRequired
}

export default PointsCash



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/PointsCash.js